<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex justify-end">
        <ButtonComp @click="showExportData" text-button="Generar reporte" icon-but="fas fa-file" class-color="success"
          normal-button />
      </v-col>
    </v-row>

    <!-- consultar -->
    <v-row>
      <v-col cols="12" md="2" sm="2" class="py-0">
        <v-autocomplete label="Nivel" v-model="filtro.id_nivel" :items="lista_filtro_niveles" item-value="id"
          item-text="desc_nivel" @change="changeFiltroNivel()" autocomplete="off">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="2" sm="2" class="py-0">
        <v-autocomplete label="Grado" v-model="filtro.id_grado" :items="lista_filtro_grados" item-value="id"
          item-text="desc_grado" @change="changeFiltroGrado()" autocomplete="off">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="2" sm="2" class="py-0">
        <v-autocomplete label="Sección" v-model="filtro.id_seccion" :items="lista_filtro_secciones" item-value="id"
          item-text="nombre_seccion" @change="changeFiltroSeccion()" autocomplete="off">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="3" sm="3" class="py-0">
        <v-text-field label="Documento de identidad" type="text" v-model="filtro.documento_identidad"
          @change="changeFiltroDocumentoIdentidad()">
        </v-text-field>
      </v-col>

      <v-col cols="12" md="3" sm="3" class="py-0">
        <v-text-field label="Estudiante" type="text" v-model="filtro.nombre_estudiante"
          @change="changeFiltroNombreEstudiante()">
        </v-text-field>
      </v-col>

      <v-col cols="12">
        <ComundataTablecomp :headers="PagosRealizadosHeaders" :items="listItems" :search="search"
          item-key="id_asig_movimiento_pago" :loading="loading">
          <template v-slot:fecha_pago="{ item }">
            {{ item.fecha_pago | filtroFecha }}
          </template>

          <template v-slot:verpago="{ item }">
            <ButtonComp v-if="componenteEvento.editar_submodulo" verButton @click="showBoleta(item)"
              tooltip-text="Ver pago realizado" />
          </template>

          <template v-slot:url_comprobante="{ item }">
            <ButtonComp v-if="componenteEvento.editar_submodulo" @click="download(URL_SPACE + '/' + item.url_comprobante)"
              download-button tooltip-text="Descargar comprobante" />
          </template>


        </ComundataTablecomp>
      </v-col>
    </v-row>


  </div>
</template>

<script>
import axios, { BUCKET_ORIGIN_SPACE } from "../../../../helpers/axios";
import CommonRules from "../../commonRules";
import ComundataTablecomp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { PagosRealizadosHeaders } from '../../../../helpers/headersTable';

export default {
  components: {
    ComundataTablecomp,
    ButtonComp
  },
  data: () => ({
    paramComponente: { id_submodulo: 2, id_modulo: 4 },
    dataSession: sessionStorage,
    PagosRealizadosHeaders,
    selectedItems: [],
    showDialog: false,
    btnIsSaving: false,
    loading: false,
    filtro: {
      id_nivel: null,
      id_grado: null,
      id_seccion: null,
      documento_identidad: null,
      nombre_estudiante: null
    },
    search: "",
    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    rul: CommonRules(),
    URL_SPACE: BUCKET_ORIGIN_SPACE,
    listItems: [],
    lista_filtro_niveles: [],
    lista_filtro_grados: [],
    lista_filtro_secciones: [],
    isNew: true,
    editedItem: {},
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    this.getListaNivelesFiltro();
    this.getListaAsigPagoPendientes();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    async changeFiltroNivel() {
      await this.getListaGradosFiltro();
      await this.getListaAsigPagoPendientes();
    },

    async changeFiltroGrado() {
      await this.getListaSeccionesFiltro();
      await this.getListaAsigPagoPendientes();
    },

    async changeFiltroSeccion() {
      await this.getListaAsigPagoPendientes();
    },

    async changeFiltroDocumentoIdentidad() {
      await this.getListaAsigPagoPendientes();
    },

    async changeFiltroNombreEstudiante() {
      await this.getListaAsigPagoPendientes();
    },

    /// FILTROS
    getListaNivelesFiltro() {
      this.lista_filtro_niveles = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: this.dataSession.id_ano_lectivo,
      };

      axios
        .post("/tesoreria/common/nivel", params)
        .then((response) => {
          this.lista_filtro_niveles = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaGradosFiltro() {
      this.lista_filtro_grados = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_nivel: this.filtro.id_nivel
      };

      axios
        .post("/sistema/integral/getGradoAdm/", { filter: params })
        .then((response) => {
          this.lista_filtro_grados = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaSeccionesFiltro() {
      this.lista_filtro_secciones = [];
      const params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: this.dataSession.id_ano_lectivo,
        id_nivel: this.filtro.id_nivel,
        id_grado: this.filtro.id_grado
      };
      axios
        .post("/tesoreria/common/seccion", params)
        .then((response) => {
          this.lista_filtro_secciones = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    showBoleta(item) {
      window.open(item.url_boleta, '_BLANK');
    },

    async download(url) {
      await this.$Files["downloadFetch"]({ url });
    },

    async getListaAsigPagoPendientes() {
      this.selectedItems = [];
      this.loading = true;
      this.filtro.id_colegio = this.dataSession.id_colegio;
      this.filtro.id_anio = this.dataSession.id_ano_lectivo;
      await axios
        .post("/tesoreria/asignacion/pago_realizado/consulta", this.filtro)
        .then((response) => {
          this.listItems = response.data;
          this.loading = false;
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
          this.loading = false;
        });
    },

    async showExportData() {
      try {
        const params = this.filtro;
        const nivel_desc = this.lista_filtro_niveles.filter(x => x.id == params.id_nivel);
        params.nivel_desc = nivel_desc.length > 0 ? nivel_desc[0]['desc_nivel'] : '';
        const grado_desc = this.lista_filtro_grados.filter(x => x.id == params.id_grado);
        params.grado_desc = grado_desc.length > 0 ? grado_desc[0]['desc_grado'] : '';
        const nombre_seccion = this.lista_filtro_secciones.filter(x => x.id == params.id_seccion);
        params.nombre_seccion = nombre_seccion.length > 0 ? nombre_seccion[0]['nombre_seccion'] : '';
        params.id_anio = this.dataSession.id_ano_lectivo;
        params.id_colegio = this.dataSession.id_colegio;

        let response = await axios.post("/tesoreria/report/consulta/rpt_pagos_realizados", params);
        if (response.data.error == 1) {
          this.setEnviarMens({ tipo: "E", mensaje: `${response.data.message}`, tiempo: null });
        }
        else {
          let archivoADescargar = '';
          let dataResponse = response.data
          this.setEnviarMens({ tipo: dataResponse.messageT, mensaje: dataResponse.message, tiempo: 3000 })
          this.generandoReporte = 0
          if (dataResponse.messageT == 'S') {
            archivoADescargar = dataResponse.fileToDownload;
            axios({
              url: '/tesoreria/report/bajarReporte/' + dataResponse.nameReport,
              method: 'GET',
              responseType: 'blob',
            }).then((response) => {
              this.setEnviarMens({ tipo: 'S', mensaje: 'Descargando reporte', tiempo: 3000 })

              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', archivoADescargar);
              document.body.appendChild(link);
              link.click();
              link.remove()
              window.URL.revokeObjectURL(url);
            });
          }
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
  },
};
</script>